import React, { FC, ReactNode } from 'react'
import { Helmet } from 'react-helmet'
import styles from 'styles/components/layout.module.scss'
import { Header } from 'components/Header'

type Props = {
  title: string
  children: ReactNode
}

const PrintLayout: FC<Props> = (props) => {
  const { children, title } = props

  return (
    <>
      <Helmet>
        <title>{title} | sacri for owner</title>
      </Helmet>
      <Header isPrintLayout={true} />
      <main className={styles.main}>
        <section className={styles.print}>{children}</section>
      </main>
    </>
  )
}

export default PrintLayout
